import { WorkforceCalendarData } from "PFApp/booking/parts/overview/context/booking_overview_context.types";
import { useBookingsOverviewContext } from "PFApp/booking/parts/overview/context/bookings_overview_context";
import { CalendarGranularity } from "PFApp/booking/types";
import React, { JSX } from "react";

import { DaysOverlay } from "./days_overlay";
import { WeeksOverlay } from "./weeks_overlay";

export const BookingDurationOverlay = (): JSX.Element | null => {
  const {
    calendarData: { calendarGranularity }
  } = useBookingsOverviewContext<WorkforceCalendarData>();

  return <>{calendarGranularity === CalendarGranularity.Daily ? <DaysOverlay /> : <WeeksOverlay />}</>;
};
